import { Button } from "antd";
import Page from "../shared/ui/components/Page";
import WorkflowList from "../widgets/WorkflowList";
import { PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";


export default function Workflows() {
  const navigate = useNavigate();

    const handleCreateWorkflow = () => {
      navigate("/create-workflow");
    };
  const CreateButton = (
    <Button
      color="primary"
      variant="solid"
      icon={<PlusOutlined />}
      onClick={handleCreateWorkflow}
    >
      Create Workflow
    </Button>
  );
  return (
    <Page title="Workflows" extra={CreateButton} content={<WorkflowList />} />
  );
}
